import { SALES_TAX_ITEM_NAME } from '@/constants/AppItemNames'
import _get from 'lodash/get'
import Mtxs from '@/constants/Mutations'

export const state = {
  orderItems: [],
} // state

export const mutations = {
  [Mtxs.SET_ORDER_ITEMS](state, items) {
    state.orderItems = items
  },
} // mutation

export const getters = {
  getOrderItems: (state) => state.orderItems,
  getValidOrderItems: (state) => {
    return state.orderItems
      .filter(
        (oi) => _get(oi, 'fields.Item[0]') || _get(oi, 'fields["Item Name"]')
      )
      .filter(
        (oi) =>
          !(
            _get(oi, 'fields["Item Name"]') === SALES_TAX_ITEM_NAME &&
            Number(_get(oi, 'fields["Item Price"]')) === 0
          )
      )
  },
} // getters

export const actions = {} // actions
